import React from "react";

import metaPixel from "../../utils/metaPixel";
import googleTagManager from "../../utils/googleTagManager";
import CookieConsent from "../../utils/CookieConsent";
import {getSellerTracking} from "../../utils/sellerTrackingConfig";

// Tagi oddziału z linku afiliacyjnego startują dopiero po zgodzie marketingowej (od razu,
// jeśli była wyrażona wcześniej, albo w momencie zapisania jej w banerze CookiesInfo).
export default function useSellerTracking(sellerCode) {
    const {metaPixelId, gtmContainerId} = getSellerTracking(sellerCode);
    const [marketingConsent, setMarketingConsent] = React.useState(CookieConsent.hasMarketingConsent);

    React.useEffect(() => {
        return CookieConsent.onChange(() => setMarketingConsent(CookieConsent.hasMarketingConsent()));
    }, []);

    React.useEffect(() => {
        if (!marketingConsent) {
            return;
        }

        if (metaPixelId) {
            metaPixel.init(metaPixelId);
        }

        if (gtmContainerId) {
            googleTagManager.init(gtmContainerId);
        }
    }, [metaPixelId, gtmContainerId, marketingConsent]);
}
